function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.56778 4.36407C3.25733 4.23325 2.89568 4.29942 2.64547 4.53266C2.39522 4.76602 2.3037 5.12259 2.41197 5.44189L6.09521 15.9999L30.4759 15.9999L3.56778 4.36407Z",
  fill: "#9A8EDE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.09517 16.7619L2.34552 27.0543C2.24156 27.3631 2.32518 27.7071 2.55851 27.9404C2.56576 27.9477 2.5731 27.9548 2.58072 27.9619C2.83089 28.1952 3.19181 28.2621 3.50121 28.1324L30.4761 16.7619L6.09517 16.7619Z",
  fill: "#9A8EDE"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29.3621,
  height: 29.3621,
  fill: "white",
  transform: "translate(11.2424 -4.75989) rotate(45)"
})));

var SvgBtnSend = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBtnSend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/btn-send.f1430e0d.svg";
export { ForwardRef as ReactComponent };